import React from "react";
import { useAuth } from "../lib/auth";
import AdminDashboard from "./dashboards/AdminDashboard";
import CustomerDashboard from "./dashboards/CustomerDashboard";
import AgentDashboard from "./dashboards/AgentDashboard";
import AffiliateDashboard from "./dashboards/AffiliateDashboard";

export default function Dashboard() {
  const { user } = useAuth();
  if (!user) return null;
  if (user.role === "admin" || user.role === "staff") return <AdminDashboard />;
  if (user.role === "agent") return <AgentDashboard />;
  if (user.role === "affiliate") return <AffiliateDashboard />;
  return <CustomerDashboard />;
}
